import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, FormControlLabel, Switch, TextField } from '@material-ui/core';
import { ADD, DRAFT, EDIT, EMAIL, globalData, MANUAL, VIEW } from '../../../../common/common';
import lImg from '../../../../assets/estate-manual.js';
import rImg from '../../../../assets/estate-email.js';
import logo from '../../../../assets/mark-mtlawllc.png';

const Root = styled(Box)({
    width: '100%',
    height: '430px',
    padding: '0 10px',
    '& .textFieldF': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .textTitle': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .text-wapper': {
        width: '50%',
        paddingRight: '15px',
        '& .text-field': {
            width: '100%',
            // backgroundColor: '#FFFFFF',
        },
    },
    '& .text-title': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .w-100': {
        width: '100%',
    },
    '& .btn-area': {
        width: '100%',
        textAlign: 'center',
        padding: '20px',
        '& .btn-wapper': {
            width: '380px',
            position: 'relative',
            padding: '20px',
            boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            cursor: 'pointer',
            '& .title': {
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#9B9B9B',
            },
            '& .lImg': {
                width: '100px',
                height: '100px',
                background: `url(${lImg}) no-repeat center top/cover`,
            },
            '& .rImg': {
                width: '100px',
                height: '100px',
                background: `url(${rImg}) no-repeat center top/cover`,
            },
            '& .logoImg': {
                width: '69px',
                height: '16px',
                position: 'absolute',
                right: '30px',
                bottom: '20px',
                background: `url(${logo}) no-repeat center top/cover`,
            },
            '& .btn-line': {
                width: '100%',
                height: '1px',
                backgroundColor: '#9B9B9B',
                margin: '20px 0',
            },
        },
        '& .btn-wapper:hover': {
            backgroundColor: '#1A9AE7',
            color: '#fff',
            '& .title': {
                color: '#fff',
            },
            '& .btn-line': {
                backgroundColor: '#fff',
            }
        },
        '& .btn-wapper-select': {
            backgroundColor: '#1A9AE7',
            color: '#fff !important',
            '& .title': {
                color: '#fff !important',
            },
            '& .btn-line': {
                backgroundColor: '#fff !important',
            }
        },
        '& .role-btn': {
            fontSize: '15px',
            margin: '0 30px'
        }
    },
    '& .prompt-wapper': {
        width: '100%',
        padding: '0 20px',
        '& .prompt': {
            width: '100%',
            padding: '20px',
            background: '#F4F4F4',
            borderRadius: '8px',
        },
        '& .prompt-btn': {
            color: '#1A9AE7',
            cursor: 'pointer',
            fontWeight: 'bold',
        },
    },
})

class InputModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            first_name: "",
            last_name: "",
            email: "",
            isSendEmail: false,
            showInputEmail: true,
            btnName: this.btnName(this.props.state)
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectType = this.handleSelectType.bind(this);
        this.handleResendEmail = this.handleResendEmail.bind(this);
    }
    render() {
        const {
            first_name,
            last_name,
            email,
            isSendEmail,
            showInputEmail,
        } = this.state;
        const {
            epStatus,
            enduserFilled
        } = this.props;
        const emailView = () => {
            if (isSendEmail) {
                if (showInputEmail) {
                    return <div className="flow" style={{ display: isSendEmail ? '' : 'none' }}>
                        <div className="text-wapper">
                            <div className="text-title">Client First Name</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="text-field"
                                value={first_name}
                                onChange={e => this.handleChange(e, 'first_name')}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Client Last Name</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="text-field"
                                value={last_name}
                                onChange={e => this.handleChange(e, 'last_name')}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        <div className="text-wapper">
                            <div className="text-title">Email</div>
                            <TextField
                                disabled={this.isDisabled()}
                                className="text-field"
                                value={email}
                                onChange={e => this.handleChange(e, 'email')}
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                        {/* <div className="text-wapper">
                        <div className="text-title">Subject</div>
                        <TextField
                            disabled={this.isDisabled()}
                            className="text-field"
                            value={subject}
                            onChange={e => this.handleChange(e, 'subject')}
                            margin="dense"
                            variant="outlined"
                        />
                    </div> */}
                    </div>
                } else if (enduserFilled && epStatus === EMAIL) {
                    return <div className="prompt-wapper">
                        <div className="prompt h h-c">The user has filled in</div>
                    </div>
                } else {
                    return <div className="prompt-wapper">
                        <div className="prompt h h-c">The email was sent successfully. Please wait for the user to fill in, or&nbsp;<div className="prompt-btn" onClick={() => this.handleResendEmail()}>resend the email</div></div>
                    </div>
                }
            }
        }
        return (
            <Root>
                <div className="btn-area h h-bt">
                    <div className={`btn-wapper c ${isSendEmail ? "" : "btn-wapper-select"}`} onClick={() => this.handleSelectType(false)}>
                        <div className="title">Fill in the content manually</div>
                        <div className="btn-line"></div>
                        <div className="lImg"></div>
                        <div className="logoImg"></div>
                    </div>
                    <div className={`btn-wapper c ${isSendEmail ? "btn-wapper-select" : ""}`} onClick={() => this.handleSelectType(true)}>
                        <div className="title">Send an email to the user to fill in</div>
                        <div className="btn-line"></div>
                        <div className="rImg"></div>
                        <div className="logoImg"></div>
                    </div>
                </div>
                {emailView()}
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    // componentDidUpdate(prevProps) {
    //     const {
    //         first_name,
    //         last_name,
    //         email,
    //         epStatus,
    //     } = this.props;
    //     if (epStatus !== prevProps.epStatus) {
    //         const isSendEmail = epStatus === EMAIL ? true : false;
    //         console.log("uuuuu", epStatus)
    //         this.setState(() => ({
    //             first_name: first_name ? first_name : "",
    //             last_name: last_name ? last_name : "",
    //             email: email ? email : "",
    //             isSendEmail,
    //             epStatus,
    //             showInputEmail: isSendEmail
    //         }));
    //     }
    // }
    initData() {
        const {
            first_name,
            last_name,
            email,
            epStatus,
        } = this.props;
        const isSendEmail = epStatus === EMAIL ? true : false;
        this.setState(() => ({
            first_name: first_name ? first_name : "",
            last_name: last_name ? last_name : "",
            email: email ? email : "",
            isSendEmail,
            epStatus,
            showInputEmail: !isSendEmail
        }))
    }
    handleChange(e, name) {
        const value = e.target.value;
        globalData.sendEmailData[name] = value;
        this.setState(() => ({
            [name]: value
        }))
        this.props.setToDoc(name, value)
    }
    handleSelectType(isSendEmail) {
        globalData.sendEmail = isSendEmail;
        this.setState({
            isSendEmail,
            showInputEmail: true,
        });
        this.props.sendEmail();
    }
    handleResendEmail() {
        this.setState({
            showInputEmail: true,
        });
    }
    doNext() {
        const {
            first_name,
            last_name,
            email,
            isSendEmail,
        } = this.state;
        const { enduserFilled } = this.props;
        if (!isSendEmail) {
            return true;
        } else {
            if (!first_name || !last_name || !email) {
                return enduserFilled ? true : false;
            } else {
                return true;
            }
        }
    }
    doSendEmail(){
        this.setState({
            showInputEmail: false,
        })
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default InputModel;